// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"3430":"01d9f358","8112":"3ee5dff5"}[chunkId] + ".css";
};